import '..//..//..//mixins.js'
var Plotly = require('./../../../custom_bundles/custom-plotly.js');

export default {
  name: 'ploter',
  props: {performanceData: null},
  data() {
    return {
      responseData : null,
      isin:this.$route.params.ISIN,
      selected:'',
      benchmarks: [],
      days: 30,
      isEndpointError: false,
      benchmarkIsin: "",
      benchmarkOption: false,
      timeOption: false
    }
  },
  beforeMount () {
    

  },
  computed:{

  },
  mounted () {
    window.addEventListener("resize", this.myEventHandler);
    console.log(this.performanceData)
    this.loadData();
  }, 
  destroyed() {
    window.removeEventListener("resize", this.myEventHandler);
  },
  methods: {
    myEventHandler() {
      console.log("myeventhandler");
      this.plotTimeSeries(this.days, 'chart', true)
    },
    loadData: async function() { // since returns a list, need to get one level down to dictionaries
      this.benchmarkIsin = this.performanceData["security_prices_benchmarks"]["isin"];
      this.stockData = this.performanceData["security_prices"]
      this.benchmarkData= this.performanceData["security_prices_benchmarks"]
      this.benchmarkComparison(30, 'chart', true);
      this.buttonActivation("nav-bar-plot", "btn");
      
    },
    plotActiveTimeSeries: async function(days) {
      this.days = days;
        if(document.getElementById('evolution').classList.contains("active"))
        {
          this.benchmarkComparison(days, 'chart', true);
        }
        else{
          this.plotTrend('chart');

        }
      
    },
    plotTrend: function(divName) {
      this.timeOption = false;
      // normalize the data
      console.log("portfolio", this.performanceData)
      let dates = this.performanceData['trend_plot']["date"];
      let prices = this.performanceData['trend_plot']["price"];
      let lower_boundaries = this.performanceData['trend_plot']["lower_boundary"];
      let upper_boundaries = this.performanceData['trend_plot']["upper_boundary"];

      var price = {
        x:dates,
        y:prices,
        opacity:1,
        name: this.performanceData['profile']["name"],
        mode: 'lines',
        line: {
          color:'#FF6816',
          width: 3
        },
        showlegend: true,
        hovertemplate: '%{y} €<extra></extra>'
      };
      var lower_boundary = {
        x:dates,
        y:lower_boundaries,
        opacity:1,
        name:'Trendkanal',
        mode: 'lines',
        line: {
          width: 2,
          color:'#333333'
        },
        showlegend: true,
        hovertemplate: '%{y} €<extra></extra>'
      };
  
      var upper_boundary = {
        x:dates,
        y:upper_boundaries,
        opacity:1,
        name:'Trendkanal',
        fill: 'tonexty',
        fillcolor: 'rgba(51, 51, 51, 0.2)',
        mode: 'lines',
        line: {
          color:'#333333',
          width: 2
        },
        showlegend: false,
        hovertemplate: '%{y} €<extra></extra>'
      };
      var data_prices;
        if (lower_boundaries[0] == 0){
          data_prices = [price];
        }
        else{
          data_prices = [lower_boundary, upper_boundary,price];
        }

        var num_observations = dates.length;

  
          var layout_prices = {
            paper_bgcolor:'#FFFFFF',
            plot_bgcolor:'#FFFFFF',
            hovermode:'x',
            autosize:true,
            legend:{'font': {'color': 'black'}, 'bgcolor': '#FFFFFF', "orientation": "h", y: -0.2},
            xaxis:{'color': 'black','gridcolor': '#FFFFFF', fixedrange: true, showticklabels: true, tickvals: [1,Math.round( num_observations / 2 ), num_observations-5],tickformat: '%Y.%m.%d', type:'category'},
            yaxis:{'color': 'black','gridcolor': '#EDEDED', fixedrange: true},
            margin:{
              'l':35,
              'r':30,
              'b':5,
              't':40,
              'pad':2
          },


          };
      
          var config = {
            displayModeBar: false,
          };
          console.log("True")
          Plotly.newPlot(divName, data_prices, layout_prices, config);
    },

    benchmarkComparison: async function(days, divName) {
      this.timeOption = true;
      this.days = days;
      var benchmarkName = this.benchmarkData["name"] // structure allows for multiple benchmarks in future
      var benchmarkDatesTotal = this.benchmarkData["dates"];
      var benchmarkDataTotal = this.benchmarkData["prices"];

      console.log("selected benchmark value", benchmarkName, "days", days)

      var stockName = this.stockData["name"]
      var stockDatesTotal = this.stockData["dates"];
      var stockDataTotal = this.stockData["prices"];

      // additional slicing
      if (days != -1){ // send -1 to request full horizon
        stockDatesTotal = stockDatesTotal.slice(Math.max(stockDatesTotal.length - days, 0))
        stockDataTotal = stockDataTotal.slice(Math.max(stockDataTotal.length - days, 0))
        benchmarkDatesTotal = benchmarkDatesTotal.slice(Math.max(benchmarkDatesTotal.length - stockDatesTotal.length, 0)) // condition on portfolio length
        benchmarkDataTotal = benchmarkDataTotal.slice(Math.max(benchmarkDataTotal.length - stockDataTotal.length, 0))
      }

      else{
      // ensures that the total amount shown is restricted to length of the respective security
      benchmarkDatesTotal = benchmarkDatesTotal.slice(Math.max(benchmarkDatesTotal.length - stockDatesTotal.length, 0))
      benchmarkDataTotal = benchmarkDataTotal.slice(Math.max(benchmarkDataTotal.length - stockDataTotal.length, 0))
      // ensures that the total amount shown is restricted to length of the respective benchmark
      stockDatesTotal = stockDatesTotal.slice(Math.max(stockDatesTotal.length - benchmarkDatesTotal.length, 0))
      stockDataTotal = stockDataTotal.slice(Math.max(stockDataTotal.length - benchmarkDataTotal.length, 0))
}

      // normalize the data
      stockDataTotal = this.normalizeValues(stockDataTotal);
      benchmarkDataTotal = this.normalizeValues(benchmarkDataTotal);

      var stock = {
        x:stockDatesTotal,
        y:stockDataTotal,
        mode:'lines',
        line:{'width':3, color:'#FF6816'},
  
        opacity:1,
        name: stockName

      };
      var benchmark = {
        x:benchmarkDatesTotal,
        y:benchmarkDataTotal,
        mode:'lines',
        line:{'width':3, color:'#333333'},
        opacity:1,
        name:benchmarkName,
        

      };
          var data_prices = [stock, benchmark];
          var graphTitle;
          if (days == 30){
            graphTitle = 'Letzter Monat'
          }
          else{
            if (days == 180){
              graphTitle = 'Letzte 6 Monate'
            }
            else{
              if (days == 365){
                graphTitle = 'Letztes Jahr'
              }
              else{
                if (days == 1095){
                  graphTitle = 'Letzte 3 Jahre'
                }
                else{
                  if (days == -1){
                    graphTitle = 'Total'
                  }
                }
              }
            }
          }

          var layout_prices = {
            title : graphTitle,
            paper_bgcolor:'#FFFFFF',
            plot_bgcolor:'#FFFFFF',
            hovermode:'x',
            autosize:true,
            legend:{'font': {'color': 'black'}, 'bgcolor': '#FFFFFF', "orientation": "h", y: -0.5},
            xaxis:{'color': 'black','gridcolor': '#FFFFFF', fixedrange: true},
            yaxis:{'color': 'black','gridcolor': '#EDEDED', fixedrange: true},
            margin:{
              'l':35,
              'r':30,
              'b':5,
              't':40,
              'pad':2
          },

          };
      
          var config = {
            displayModeBar: false,
          };
          
          Plotly.newPlot(divName, data_prices, layout_prices, config);
    },


    
  }
}